import { UserPlus, Activity, BedDouble } from "lucide-react";
import { UnifiedRecord, SystemMetrics } from "../../../types";
import { BedMap } from "../../Dashboard/BedMap";
import { EarlyWarningSystem } from "../../Dashboard/EarlyWarningSystem";

interface DashboardProps {
  records: UnifiedRecord[];
  metrics: SystemMetrics | null;
  loading: boolean;
}

export function NurseDashboard({ records }: DashboardProps) {
  // Nurses usually care about a specific ward or all patients pending beds
  const pendingBeds = records.filter(r => !r.resolved_bed && r.his_clinical_status !== "Discharged");

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="flex items-center gap-3 mb-4 border-b border-white/10 pb-4">
        <UserPlus className="w-8 h-8 text-blue-400" />
        <div>
          <h2 className="text-xl font-semibold text-white">Nursing Station</h2>
          <p className="text-gray-400 text-sm">Ward status and pending bed allocations</p>
        </div>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="rounded-2xl border border-white/8 bg-white/5 p-5 flex items-center justify-between">
          <div>
            <p className="text-gray-400 text-sm">Pending Bed Allocation</p>
            <h3 className="text-3xl font-bold text-white mt-1">{pendingBeds.length}</h3>
          </div>
          <div className="w-12 h-12 rounded-full bg-amber-500/20 flex items-center justify-center">
            <Activity className="w-6 h-6 text-amber-400" />
          </div>
        </div>
        <div className="rounded-2xl border border-white/8 bg-white/5 p-5 flex items-center justify-between">
          <div>
            <p className="text-gray-400 text-sm">Total Ward Patients</p>
            <h3 className="text-3xl font-bold text-white mt-1">{records.filter(r => r.resolved_bed).length}</h3>
          </div>
          <div className="w-12 h-12 rounded-full bg-blue-500/20 flex items-center justify-center">
            <BedDouble className="w-6 h-6 text-blue-400" />
          </div>
        </div>
      </div>

      <EarlyWarningSystem records={records} />

      <BedMap records={records} />
    </div>
  );
}
